module.exports = __webpack_public_path__ + "static/media/Colette Straight Super King Headboard - 200 cm_Dark Blue.8f44841f.png";